module.exports = __webpack_public_path__ + "static/media/rw.78980691.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/rw.svg
// module id = 2200
// module chunks = 0